import React, { useContext, useMemo } from 'react'
import { StatusCodes } from '@e3dc-react/shell/Libs/websocket-status-codes'
import { Alert } from '@e3dc-react/shell/Elements/Alert'
import { useSocketConnectionContext } from '../Framework/SystemDataProvider'
import { Grid } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/**
 * Component displays an alert if one of the websocket returns an error
 */
const WebsocketAlert: React.FC = () => {
  const { t } = useCustomTranslation()
  const { wallboxChargingSocketState, batterySocketState, storageSocketState, wallboxSocketState } = useContext(useSocketConnectionContext())

  const hasError = useMemo(() => {
    return [wallboxChargingSocketState.error, batterySocketState.error, storageSocketState.error, wallboxSocketState.error].reduce(
      (previous, current) => previous || current?.code === StatusCodes.TRY_AGAIN_LATER,
      false
    )
  }, [batterySocketState, storageSocketState, wallboxChargingSocketState.error, wallboxSocketState])

  if (hasError)
    return (
      <Grid item xs={12}>
        <Alert severity="error" text={t('dashboard.errors.websocket-error')}></Alert>
      </Grid>
    )

  return null
}

export default WebsocketAlert
